import script from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsGrid.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=e5304db0&lang=css"

const __exports__ = script;

export default __exports__